import React from 'react'
import { Importer, ImporterField } from 'react-csv-importer';
// theme CSS for React CSV Importer
import "react-csv-importer/dist/index.css";

const ImportCSV = ({columns, process, onComplete}) => {

    const myAppMethod = async (rows) => {
        // required, receives a list of parsed objects based on defined fields and user column mapping;
        // may be called several times if file is large
        // (if this callback returns a promise, the widget will wait for it before parsing more data)
        process(rows)
      }

      const myAppCompleteMethod = () => {
        onComplete();
    }

    const showMyAppToastNotification = () => {

    }

    const goToMyAppNextPage = () => {

    }

    return <Importer
      dataHandler={async (rows) => {
        // required, receives a list of parsed objects based on defined fields and user column mapping;
        // may be called several times if file is large
        // (if this callback returns a promise, the widget will wait for it before parsing more data)
        // mock timeout to simulate processing
        return await process(rows)
        //new Promise((resolve) => setTimeout(resolve, 500));
      }}
      chunkSize={10000} // optional, internal parsing chunk size in bytes
      defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
      restartable={false} // optional, lets user choose to upload another file when import is complete
      onStart={({ file, fields }) => {
        // optional, invoked when user has mapped columns and started import
        console.log("starting import of file", file, "with fields", fields);
      }}
      onComplete={({ file, fields }) => {
        // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
        console.log("finished import of file", file, "with fields", fields);
        onComplete()
      }}
      /*onClose={() => {
        // optional, invoked when import is done and user clicked "Finish"
        // (if this is not specified, the widget lets the user upload another file)
        console.log("importer dismissed");
      }}*/

      processChunk={myAppMethod}
  
    // CSV options passed directly to PapaParse if specified:
    // delimiter={...}
    // newline={...}
    // quoteChar={...}
    // escapeChar={...}
    // comments={...}
    // skipEmptyLines={...}
    // delimitersToGuess={...}
    // chunkSize={...} // defaults to 10000
    // encoding={...} // defaults to utf-8, see FileReader API
  >
      {/* {columns && columns.map(c => <ImporterField key={c.id} name={c.id} label={c.label} optional={c.optional}/>)} */}
      {columns && columns.map((c) => {
        const optional =
          typeof c.required === "boolean"
            ? !c.required               // required=false => optional=true
            : (c.optional ?? false);    // rétrocompat: optional existant

        return (
          <ImporterField
            key={c.id}
            name={c.id}
            label={c.label}
            optional={optional}
          />
        );
      })}
  </Importer>

}

export default ImportCSV